import { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { UserContext } from "../contexts/userContext";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { LoadingButton } from "@mui/lab";
import { IUserWithPassword } from "../interfaces";
import { roles } from "../utils/constants";

const CreateUserModal = ({
  show,
  handleClose,
}: {
  show: boolean;
  handleClose(): void;
}) => {
  const { businessData } = useContext(UserContext);
  const [userInfo, setUserInfo] = useState({} as IUserWithPassword);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (type: string, value: string) => {
    setUserInfo({ ...userInfo, [type]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const functions = getFunctions();
    const createEmployeeFunction = httpsCallable(functions, "createEmployee");

    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      try {
        await user.getIdToken(true);
        await createEmployeeFunction({
          ...userInfo,
          business: businessData.uid,
        });
        setUserInfo({} as IUserWithPassword);
        handleClose();
      } catch (error) {
        console.error("Error creating employee:", error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <Dialog onClose={handleClose} open={show}>
      <IconButton onClick={handleClose} className="close-icon">
        <span className="material-symbols-rounded">close</span>
      </IconButton>
      <DialogTitle>Nuevo usuario</DialogTitle>
      <Grid container sx={{ p: 4 }} spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label="Nombre"
            name="name"
            fullWidth
            value={userInfo.name}
            size="small"
            placeholder="Nombre"
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="role-label">Rol</InputLabel>
            <Select
              labelId="role-label"
              name="role"
              value={userInfo.role || ""}
              label="Rol"
              size="small"
              onChange={({ target: { name, value } }) =>
                handleChange(name, value)
              }
            >
              {roles.map(({ value, title }, index) => (
                <MenuItem key={index} value={value}>
                  {title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            label="Correo electronico"
            name="email"
            value={userInfo.email}
            size="small"
            fullWidth
            placeholder="Correo electronico"
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl fullWidth size="small">
            <OutlinedInput
              type={showPassword ? "text" : "password"}
              placeholder="Ingresar contraseña"
              className="f-s-14"
              value={userInfo.password || ""}
              onChange={(e) => handleChange("password", e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    <span className="material-symbols-rounded">
                      {showPassword ? "visibility" : "visibility_off"}
                    </span>
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="end"
          alignItems="center"
          size={{ xs: 12 }}
          sx={{ mt: 3 }}
          spacing={1}
        >
          <Button
            color="secondary"
            variant="outlined"
            size="small"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            size="small"
            color="secondary"
            disabled={!userInfo || loading}
            onClick={handleSubmit}
          >
            Crear
          </LoadingButton>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CreateUserModal;
